import { render } from "./details-list.vue?vue&type=template&id=1423745b"
import script from "./details-list.vue?vue&type=script&lang=js"
export * from "./details-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__